import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Pause from '@material-ui/icons/Pause';
import { makeStyles } from '@material-ui/styles';
import { RouterLink } from 'mobx-state-router';
import React from 'react';

import Tooltip from 'src/components/general/Tooltip';
import { ADD_ADMIN_BLOCK_BUTTONS, OBSERVABILITY_MY_DAY_TODAY } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import { PageTitle } from 'src/nightingale/components/common/PageTitle/PageTitle';
import { useObservability } from 'src/observability/useObservability';
import { BoulderColors } from 'src/util/brand';

const ScheduleWidgetTitleBar: React.FC<{
  providerId: string;
  createEvent: (options?: any, openEditModal?: boolean) => void;
}> = ({ providerId, createEvent }) => {
  const classes = useStyles();
  const showAddAdminBlockButtons = useFeatureFlag(ADD_ADMIN_BLOCK_BUTTONS);
  const enableObservability = useFeatureFlag(OBSERVABILITY_MY_DAY_TODAY);
  const sendStaffEvent = useObservability(enableObservability);

  const createAdminBlockEvent = (duration: number) => {
    createEvent(
      {
        type: 'appointment_virtual',
        subType: 'blocked_break',
        start: new Date(),
        duration,
      },
      false,
    );
    sendStaffEvent({
      eventType: 'myDayToday:adminTimeAdded',
      userId: providerId,
      details: { duration },
    });
  };

  return (
    <header className={classes.titleBar}>
      <div className={classes.title}>
        <PageTitle>Today&apos;s Schedule</PageTitle>
      </div>
      <div className={classes.spacer} />

      {showAddAdminBlockButtons && (
        <>
          <div className={classes.button}>
            <Tooltip title="Add a 10 min admin block starting now">
              <Fab size="small" color="secondary" onClick={() => createAdminBlockEvent(10)}>
                <Pause />
              </Fab>
            </Tooltip>
            <div className={classes.buttonLabel}>10m</div>
          </div>

          <div className={classes.button}>
            <Tooltip title="Add a 30 min admin block starting now">
              <Fab size="small" color="secondary" onClick={() => createAdminBlockEvent(30)}>
                <Pause />
              </Fab>
            </Tooltip>
            <div className={classes.buttonLabel}>30m</div>
          </div>
        </>
      )}

      {!showAddAdminBlockButtons && (
        <div className={classes.button}>
          <Tooltip title="Add event">
            <Fab size="small" color="secondary" onClick={createEvent}>
              <AddIcon />
            </Fab>
          </Tooltip>
        </div>
      )}

      <div className={classes.button}>
        <RouterLink
          routeName="showProvider"
          params={{ id: providerId }}
          queryParams={{ view: 'week' }}
        >
          <Tooltip title="Weekly View">
            <Fab size="small" color="secondary">
              <CalendarToday />
            </Fab>
          </Tooltip>
        </RouterLink>
      </div>
    </header>
  );
};

const useStyles = makeStyles({
  titleBar: {
    display: 'flex',
  },
  spacer: {
    flex: '1 1 100%',
    gap: 8,
  },
  title: {
    flex: '0 0 auto',
  },
  button: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: -6,
    marginLeft: 8,
    position: 'relative',
  },
  buttonLabel: {
    position: 'absolute',
    bottom: 18,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 6px 2px 6px',
    borderRadius: 12,
    border: `1px solid ${BoulderColors.Gray5}`,
    color: BoulderColors.Gray5,
    background: BoulderColors.White,
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 1,
  },
});

export default ScheduleWidgetTitleBar;
